import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

export default function PendingApprovalPage() {
  const navigate = useNavigate()
  const { logout } = useAuthStore()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="text-center">
      <div className="mx-auto h-16 w-16 bg-yellow-100 rounded-full flex items-center justify-center">
        <svg className="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h2 className="mt-4 text-2xl font-bold text-gray-900">In attesa di approvazione</h2>
      <p className="mt-2 text-gray-600">
        Il tuo account e in attesa di approvazione da parte di un amministratore.
      </p>
      <p className="mt-4 text-sm text-gray-500">
        Riceverai una notifica via email quando il tuo account sara approvato.
      </p>
      <button onClick={handleLogout} className="mt-6 btn-secondary">
        Esci
      </button>
    </div>
  )
}
